<template>
  <div class="m-auto w-75">
	    <el-dialog 
	     title="修改密码"
	     width="50%"
		 :visible.sync='visible'
	    >  
	     <div class="icon-content w-100 dialog-30 " style="overflow-y: auto;">
	    	   <el-form    ref="form"  label-width="80px">
	    		   <el-form-item  label='原密码'>
	    		   <el-input placeholder='请填写原密码'  type='text' v-model='password'></el-input>
	    		    </el-form-item>
	    			<el-form-item  label='新密码'>
	    			<el-input placeholder='请填写新密码'  type='text' v-model='newPassword'></el-input>
	    			 </el-form-item>
	    			 <el-form-item  label='确认密码'>
	    			 <el-input placeholder='请填写新密码'  type='text' v-model='okPassword'></el-input>
	    			  </el-form-item>
	    		   </el-form>
	    	  </div>
	    	    <span slot="footer" class="dialog-footer">
	    	      <el-button @click="visible=false">{{$t("dialog.cancel")}}</el-button>
	    	      <el-button type="primary" @click="passwordClick">{{$t("dialog.confirm")}}</el-button>
	    	    </span>
	    	  </el-dialog> 
    <div class="info-wrap mt-4">
      <!-- 头像开始 -->
      <div class="avatar">
          <img :src="storeUser.avatarUrl?storeUser.avatarUrl:defaultMans" width="140" height="140" />
         
         <!-- <el-upload
  action="http://localhost:2364/api/api/Upload/PostUploadAvatar"
  :show-file-list="false" :headers="authHeaders"
  :on-success="handleAvatarSuccess"
  :on-error="errorAvatarUpload"
  :before-upload="beforeAvatarUpload"> 
   <span class="avatar-edit text-white el-dropdown-link" style="display: block;">{{$t("personal.modifyAvatar")}}</span>
</el-upload> -->
      </div>
      <!-- 头像结束 -->
      <!-- <p class="account">{{storeLanguage=='en'?storeUser.englishName:storeUser.name}}</p> -->
	      <p class="account">{{storeUser.nickName?storeUser.nickName:storeUser.name}}</p>
      <p class="text">
        <span class="grey">{{$t("personal.currentIdentity")}}：</span>   
        <span class="gray">{{getRoleName}}</span>
        <span class="grey ml-4">{{$t("personal.accountType")}}：</span>
        <span class="gray">{{storeUser.roleList.length>1?'多个身份帐户':'个人身份账户'}}</span>
      </p>
     
    </div>
    <el-row>
      <el-col class="mb-4"  :span="24">
        <el-card class="h-auto" shadow="hover">
          <table class="w-100">
            <colgroup>
              <col width="8%" />
              <col width="45%" />
              <col width="25%" />
              <col width="22%" />
            </colgroup>
            <tr>
              <td align="left">
                <img
                  class="til-icon"
                  src="../../assets/icon_password.png"
                  height="45"
                />
              </td>
              <td align="left">
                <p class="title">{{$t("personal.accountPassword")}}</p>
                <p class="text">{{$t("personal.accountPasswordDec")}}</p>
              </td>
              <td align="left">
                <i class="el-icon-success text-success"></i>
                <span class="text-success">{{$t("personal.finish")}}</span>
              </td>
              <td align="right">
                <el-button  @click="visible=true">{{$t("button.modify")}}</el-button>
              </td>
            </tr>
          </table>
        </el-card>
      </el-col>
    </el-row>


<!-- <el-row>
      <el-col class="mb-4"  :span="24">
        <el-card class="h-auto" shadow="hover">
          <table class="w-100">
            <colgroup>
              <col width="8%" />
              <col width="45%" />
              <col width="25%" />
              <col width="22%" />
            </colgroup>
            <tr>
              <td align="left">
                <img
                  class="til-icon"
                  src="../../assets/icon_userdata.png"
                  height="45"
                />
              </td>
              <td align="left">
                <p class="title">{{$t("personal.accountInfo")}}</p>
                <p class="text">{{$t("personal.accountInfoDec")}}</p>
              </td>
              <td align="left">
                <i class="el-icon-success text-gray"></i>
                <span class="gray">{{$t("personal.finish")}}</span>
              </td>
              <td align="right">
                <el-button>{{$t("button.modify")}}</el-button>
              </td>
            </tr>
          </table>
        </el-card>
      </el-col>
    </el-row> -->

     <!-- <el-col class="mb-4"  :span="24">
        <el-card class="h-auto" shadow="hover">
          <table class="w-100">
            <colgroup>
              <col width="8%" />
              <col width="45%" />
              <col width="25%" />
              <col width="22%" />
            </colgroup>
            <tr>
              <td align="left">
                <img
                  class="til-icon"
                  src="../assets/icon_rename.png"
                  height="45"
                />
              </td>
              <td align="left">
                <p class="title">{{$t("personal.realName")}}</p>
                <p class="text">{{$t("personal.realNameDec")}}</p>
              </td>
              <td align="left">
                <i class="el-icon-success text-gray"></i>
                <span class="gray">{{$t("personal.finish")}}</span>
              </td>
              <td align="right">
                <el-button>{{$t("button.modify")}}</el-button>
              </td>
            </tr>
          </table>
        </el-card>
      </el-col>
    </el-row> -->


<el-col class="mb-4"  :span="24">
        <el-card class="h-auto" shadow="hover">
          <table class="w-100">
            <colgroup>
              <col width="8%" />
              <col width="45%" />
              <col width="25%" />
              <col width="22%" />
            </colgroup>
            <tr>
              <td align="left">
                <img
                  class="til-icon"
                  src="../../assets/icon_bindmobile.png"
                  height="45"
                />
              </td>
              <td align="left">
                <p class="title">{{$t("personal.contactMobile")}}</p>
                <p class="text">{{$t("personal.contactMobileDec")}}</p>
              </td>
              <td align="left">
                <i :class="telStatus?'text-success':''" class="el-icon-success text-gray"></i>
                <span :class="telStatus?'text-success':'gray'">{{$t("personal.finish")}}</span>
              </td>
              <td align="right">
				  <el-popover
				    placement="top"
				    trigger="click">
				   <el-input type="text" placeholder="请填写手机号" v-model="tel">
				    <el-button slot="append" icon="el-icon-check" type="primary" @click="telClick()"></el-button></el-input>
				    <el-button slot="reference">{{$t("button.modify")}}</el-button>
				  </el-popover>
                <!-- <el-button>{{$t("button.modify")}}</el-button> -->
              </td>
            </tr>
          </table>
        </el-card>
      </el-col>
    </el-row>


<el-col class="mb-4"  :span="24">
        <el-card class="h-auto" shadow="hover">
          <table class="w-100">
            <colgroup>
              <col width="8%" />
              <col width="45%" />
              <col width="25%" />
              <col width="22%" />
            </colgroup>
            <tr>
              <td align="left">
                <img
                  class="til-icon"
                  src="../../assets/icon_bindemial.png"
                  height="45"
                />
              </td>
              <td align="left">
                <p class="title">{{$t("personal.contactMailbox")}}</p>
                <p class="text">{{$t("personal.contactMailboxDec")}}</p>
              </td>
              <td align="left">
                 <i :class="emailStatus?'text-success':''" class="el-icon-success text-gray"></i>
                <span :class="emailStatus?'text-success':'gray'">{{$t("personal.finish")}}</span>
              </td>
              <td align="right">
				  <el-popover
				    placement="top"
				    trigger="click">
				   <el-input type="text" placeholder="请填写邮箱" v-model="email">
				    <el-button slot="append" icon="el-icon-check" type="primary" @click="emailClick()"></el-button></el-input>
				    <el-button slot="reference">{{emailStatus?'修改':'完成'}}</el-button>
				  </el-popover>
                <!-- <el-button>{{$t("button.modify")}}</el-button> -->
              </td>
            </tr>
          </table>
        </el-card>
      </el-col>
    </el-row>


<!-- <el-col class="mb-4"  :span="24">
        <el-card class="h-auto" shadow="hover">
          <table class="w-100">
            <colgroup>
              <col width="8%" />
              <col width="45%" />
              <col width="25%" />
              <col width="22%" />
            </colgroup>
            <tr>
              <td align="left">
                <img
                  class="til-icon"
                  src="../../assets/icon_bindwechat.png"
                  height="45"
                />
              </td>
              <td align="left">
                <p class="title">{{$t("personal.bindingWeChat")}}</p>
                <p class="text">{{$t("personal.bindingWeChatDec")}}</p>
              </td>
              <td align="left">
                <i :class="storeUser.avatarUrl?'text-success':''" class="el-icon-success text-gray"></i>
                <span :class="storeUser.avatarUrl?'text-success':''">{{$t("personal.finish")}}</span>
              </td>
              <td align="right">
				<el-popover
				  placement="top"
				  width="120"
				  trigger="click">
				   <el-image
				        style="width: 100%; height: 100%"
				        :src="qrcode"
				       ></el-image>
				  <el-button slot="reference">查看</el-button>
				</el-popover>
              </td>
            </tr>
          </table>
        </el-card>
      </el-col> -->
    </el-row>
   
  </div>


  </div>
  
</template>
<script>
export default {
  data() {
    return {
	 defaultMans:require('../../assets/xiazs.jpg'),
	   qrcode:require('../../assets/qrcode_for_gh_696ded1be10d_258.jpg'),
                    authHeaders: {Authorization:"BearerSSSSSS "+localStorage.getItem('TOKEN')},
					email:'',
					tel:'',
					telStatus:false,
					emailStatus:false,
					password:'',
					newPassword:'',
					okPassword:'',
					visible:false
      }
  }, 
  mounted(){
	 // this.tel= this.$store.state.user.tel||'';
	 // this.email= this.$store.state.user.email||'';
	 this.telStatus=this.$store.state.user.tel?true:false;
	  this.emailStatus=this.$store.state.user.email?true:false;
  },
  methods: {
	  emailClick(){
		  if(!this.email){
			  this.$message.error('请填写邮箱'); return;
		  }
		  this.$axios.post('/api/Account/PostAccountEmail', JSON.stringify(this.email.toString())).then(e => {
			    this.$message.success('提交成功同步到服务器');
				let user=	  this.$store.state.user;
				user.email=this.email;
				this.$store.commit("saveUser",  e.data.user);
				  this.emailStatus=true;
		   });
	  },
	  telClick(){
	  		  if(!this.tel){
	  			  this.$message.error('请填写手机号'); return;
	  		  }
			  if(this.tel.length!=11){
			  	  			  this.$message.error('手机号格式不正确'); return;
			  }
			this.$axios.post('/api/Account/PostAccountTel',  JSON.stringify(this.tel.toString())).then(e => {
				  this.$message.success('提交成功同步到服务器');
			   let user=	  this.$store.state.user;
			   user.tel=this.tel;
			   this.$store.commit("saveUser",  e.data.user);
				  this.telStatus=true;
			 });
	  },
	  passwordClick(){
	  		  if(!this.password){
	  			  this.$message.error('请填写原密码'); return;
	  		  }
			  if(!this.newPassword){
			  	  			  this.$message.error('请填写新密码'); return;
			  }
			  if(!this.okPassword){
			  	  			  this.$message.error('请填写确认密码'); return;
			  }
	  			  if(this.okPassword!=this.newPassword){
	  			  	  			  this.$message.error('新密码与确认密码不一致'); return;
	  			  }
	  			this.$axios.post('/api/Account/PostAccountPassword',{password:this.password,newPassword:this.newPassword,okPassword:this.okPassword}).then(e => {
					  this.$message.success('提交成功同步到服务器');
					this.visible=false;
	  			 });
	  },
      handleAvatarSuccess(res, file) {
       let result=  typeof res =='string'?JSON.parse(res):res;  
       if(result.status>200){
            this.$message.error(result.message);
       }else{
          let user= this.$store.state.user;
          user.avatar=result.data;
            this.$store.commit("saveUser", user);
       } 
      },
      errorAvatarUpload(e){
        //   this.$message.error(e);
        if(e.status==401){
             localStorage.clear();
                    _this.$router.push('/login');
                    location.reload()
        }else{
            this.$message.error('Proxy error: Could not proxy request ');   
        }
       
      },
      beforeAvatarUpload(file) {
           let fileExt = file.name.replace(/.+\./, "");       
if (['jpg','png'].indexOf(fileExt.toLowerCase()) === -1){            
	  this.$message.error('上传头像图片只能是jpg,png格式');             
	 	return false;       
	  }
        if (file.size / 1024 / 1024 > 2) {
          this.$message.error('上传头像图片大小不能超过2MB');
          return false;   
        }
        return true;
      }
  },  computed: {
    storeLanguage() {
      return this.$store.state.language;
    },
	getRoleName(){
			  return this.$store.state.user.roleList.find(item=>{return item.id==this.$store.state.user.roleId}).name
	},
     storeUser() {
      return this.$store.state.user;
    }
  }
};
</script>

<style lang="css">
.el-card__body {
  height: auto!important;
}
.info-wrap {
  text-align: center;margin-bottom: 20px 
}
.info-wrap .avatar {
  float: none;
  display: inline-block;
  *display: inline;
  *zoom: 1;
  margin-right: 0;
  vertical-align: middle;
}
.info-wrap .account {
  font-size: 24px;
  line-height: 26px;
  color: #333;
  margin-top: 10px;
  margin-bottom: 10px;
}
.info-wrap .safety-bar {
  margin-top: 30px;
}
.info-wrap .avatar {
    float: none;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    margin-right: 0;
    vertical-align: middle;
}

.avatar {
     position: relative;
    overflow: hidden;
    width: 140px;
    height: 140px; 
    margin: 0;
    border-radius: 70px;
    -webkit-border-radius: 70px;
    margin-right: 30px;
}
.avatar {
    float: none;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    margin-right: 0;
    vertical-align: middle;
}

.avatar .avatar-edit {
    width: 140px;
}
.avatar-edit {
    background: rgba(0, 0, 0, 0.3);
    bottom: 0;
    display: none;
    height: 24px;
    left: 0;
    line-height: 24px;
    position: absolute;
    text-align: center;
    width: 111px;
    z-index: 9;
    color: #fff;
}
</style>
